<template>
  <section
    :class="{ 'reduce-header': getUserRole === 22 || getUserRole === 25 }"
  >
    <div class="friends-container">
      <ul
        class="friends-ul"
        v-if="filteredFriends !== false && filteredFriends.length > 0"
      >
        <transition-group name="swipe" mode="out-in" appear>
          <li
            v-for="friend in filteredFriends"
            :key="friend.friendId"
            class="friend"
            :class="{ online: friend.online !== null }"
          >
            <div
              class="loader-container-small"
              v-if="
                sendingFavRequest[
                  !friend.group_name
                    ? 'person'
                    : 'group_appointment' + friend.receiver_id
                ]
              "
            >
              <div class="loader-small"></div>
            </div>

            <template>
              <!-- Empty star -->
              <img
                class="img-star"
                :src="emptyStarIcon"
                v-if="
                  getUserRole !== 22 &&
                    getUserRole !== 25 &&
                    !friend.favourite_id &&
                    !sendingFavRequest[
                      !friend.group_name
                        ? 'person'
                        : 'group_appointment' + friend.receiver_id
                    ]
                "
                @click="
                  sendAddFavouritesRequest({
                    id: friend.receiver_id,
                    type: !friend.group_name ? 'person' : 'group_appointment',
                    providerId: userInfo.userId
                  })
                "
              />

              <!-- Filled star -->
              <img
                class="img-star"
                :src="filledStarIcon"
                v-if="
                  getUserRole !== 22 &&
                    getUserRole !== 25 &&
                    friend.favourite_id &&
                    !sendingFavRequest[
                      !friend.group_name
                        ? 'person'
                        : 'group_appointment' + friend.receiver_id
                    ]
                "
                @click="
                  sendRemoveFavouritesRequest({
                    favourite_id: friend.favourite_id,
                    id: friend.receiver_id,
                    type: !friend.group_name ? 'person' : 'group_appointment',
                    providerId: userInfo.userId
                  })
                "
              />
            </template>

            <!-- Other part -->
            <div
              class="friend-container"
              :class="{ 'no-star': getUserRole === 22 || getUserRole === 25 }"
              @click.stop.prevent="goToChat(friend.friendId)"
            >
              <div class="title">
                <span class="name">{{ friend.name }}</span>
                <span class="time">{{ friend.timeBeautify }}</span>
              </div>
              <div class="content">
                <span class="message">{{ friend.value }}</span>
                <span class="new-messages" v-if="friend.unread !== 0">
                  {{ friend.unread }}
                </span>
              </div>
            </div>
          </li>
        </transition-group>
      </ul>
      <ul class="friends-ul" v-else>
        <li>
          <div class="friend-container">
            <div class="title">
              <span class="name">No chats</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { nameMixin } from "../../../mixins/nameMixin";

import moment from "moment";

export default {
  name: "ChatDashboardSection",
  mixins: [nameMixin],
  props: {
    show: String
  },
  data() {
    return {
      emptyStarIcon: require("../../../assets/img/m_favorites-empty.png"),
      filledStarIcon: require("../../../assets/img/m_favorites.png")
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
      searchBy: "getSearchValue",
      userDetails: "getUserDetails",
      getUserRole: "getUserRole"
    }),
    ...mapGetters("chat", {
      friends: "getFriends",
      groups: "getGroups"
    }),
    ...mapGetters("favourites", {
      favouriteMode: "getFavouriteMode",
      sendingFavRequest: "getSendingFavRequest"
    }),
    allFriends() {
      // Step 1: Base friend array
      let friendsArray = new Array(
        Object.keys(this.friends).length + Object.keys(this.groups).length
      );

      // Step 2: Loop through all the keys in friends
      let curKey = 0;
      for (let key of Object.keys(this.friends)) {
        friendsArray[curKey++] = {
          ...this.friends[key],
          friendId: `user:${key}`,
          name:
            "fullName" in this.friends[key]
              ? this.friends[key].fullName
              : this.formatName(
                  this.friends[key].firstName,
                  this.friends[key].middleName,
                  this.friends[key].lastName,
                  this.friends[key].namePrefix,
                  this.friends[key].nameSuffix,
                  null,
                  "chat"
                ),
          timeBeautify: moment(this.friends[key].time).calendar()
        };
      }

      // Step 3: Loop through all the keys in groups
      for (let key of Object.keys(this.groups)) {
        friendsArray[curKey++] = {
          ...this.groups[key],
          friendId: `group:${key}`,
          name: this.groups[key].group_name,
          timeBeautify: moment(this.groups[key].time).calendar(),
          online: null
        };
      }

      // Step 3: Sort the friends by received date
      friendsArray.sort((a, b) => {
        return new Date(a.time).getTime() > new Date(b.time).getTime() ? -1 : 1;
      });

      // Step 4: Return the friends date
      return friendsArray;
    },
    filteredFriends() {
      // Step 1: Check if there are any friends
      if (!this.allFriends) {
        return false;
      }

      // Step 2: Check for favourite mode
      if (this.favouriteMode) {
        // Step 2.1: Filter
        let curFriends = this.allFriends.filter(friend => {
          return (
            friend.name
              .toLowerCase()
              .search(this.escape(this.searchBy.toLowerCase())) !== -1 &&
            friend.favourite_id !== null &&
            this.userDetails.id !== friend.friendId &&
            this.filterUserList(friend.userRole)
          );
        });

        // Step 2.2: Sort
        return curFriends.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          return -1;
        });
      }

      // Step 3: Not in favourite mode
      return this.allFriends.filter(friend => {
        return (
          friend.name
            .toLowerCase()
            .search(this.escape(this.searchBy.toLowerCase())) !== -1 &&
          this.userDetails.id !== friend.friendId &&
          this.filterUserList(friend.userRole)
        );
      });
    }
  },
  methods: {
    ...mapActions("favourites", {
      sendAddFavouritesRequest: "sendAddFavouritesRequest", // Add someone as favourite
      sendRemoveFavouritesRequest: "sendRemoveFavouritesRequest" // Remove someone as favourite
    }),
    ...mapMutations("chat", {
      setSelectedUserId: "setSelectedUserId", // Selected user id for chat when chatting with a person
      setIsGroup: "setIsGroup" // Set the group id when chatting in group
    }),
    /**
     * Go to a specific chat
     */
    goToChat(fullID) {
      const [userOrGroup, id] = fullID.split(":");
      if (userOrGroup === "group") {
        return this.$router.push(`/messenger/group/${id}`);
      }
      return this.$router.push(`/messenger/${id}`);
    },
    /**
     * Filter the list accoding to the type of list required
     */
    filterUserList(userRole) {
      switch (this.show) {
        case "all":
          return true;

        case "client":
          return userRole === "CLIENT_PORTAL_USER";

        case "person":
          return userRole === "NON_CLIENT_PORTAL_USER";

        case "group":
          return !userRole;

        case "user":
          return (
            userRole === "APP_USER" ||
            userRole === "SINGLE_SUBSCRIBER" ||
            userRole === "GROUP_PRACTICES_SUBSCRIBER" ||
            userRole === "GOI"
          );

        default:
          break;
      }
    },
    escape(s) {
      // eslint-disable-next-line no-useless-escape
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
  }
};
</script>

<style scoped>
section ul {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 0px;
}

.reduce-header {
  margin-top: 93px !important;
}

section ul li {
  list-style: none;
  padding: 15px;
  display: flex;
  align-items: center;
}

.img-star {
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 1rem;
}

section ul li:nth-child(even) {
  background-color: #f2f2f2;
}

section ul li.online {
  border-right: 5px solid lightgreen;
}

section ul li:hover {
  /* background-color: rgba(210, 109, 19, 0.1); */
  cursor: pointer;
}

section ul li div.friend-container.no-star {
  max-width: 100%;
}

section ul li div.friend-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-width: 90%;
}

section ul li div.friend-container div.title {
  display: flex;
  margin-bottom: 3px;
}

section ul li div.friend-container div.content {
  display: flex;
}

section ul li div.friend-container div.content span.message {
  color: gray;
  font-size: 13px;
  flex-grow: 1;
  max-width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
}

section ul li div.friend-container div.content span.new-messages {
  font-size: 10px;
  background-color: rgb(210, 109, 19);
  width: 20px;
  height: 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
}

section ul li div.friend-container div.title span.name {
  flex-grow: 1;
  font-weight: lighter;
  color: #383838;
}

section ul li div.friend-container div.title span.time {
  font-size: 13px;
  font-weight: lighter;
  color: gray;
}

.swipe-enter-active {
  animation: swipeIn 0.4s ease-in-out;
}

.swipe-leave-active {
  animation: swipeOut 0.4s ease-in-out;
}

.swipe-move {
  transition: all 0.4s ease-in-out;
}

.loader-container-small {
  padding: 1px 7px 0px 0px;
  margin-right: 0.7rem;
}

.loader-small {
  float: left;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #d26d13;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 0.5s linear infinite;
}

@keyframes swipeIn {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes swipeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
</style>
